import { PostSection } from "@/components/blog/PostSection";
import { PostHighlight } from "@/components/blog/PostHighlight";

export function EstrategiasSection() {
  return (
    <PostSection id="estrategias-adaptacion" title="Estrategias de adaptación al nuevo SEO">
      <p>
        Los AI Overviews no matan el SEO, lo evolucionan. Estas son las estrategias clave para 
        posicionar tu web como <strong>fuente citada</strong> por la IA de Google.
      </p>

      <h3 id="autoridad-tematica" className="text-xl font-bold text-white mt-8 mb-4">
        1. Construir autoridad temática con clusters de contenido
      </h3>
      <p>
        Google ya no premia artículos aislados sobre temas amplios. Los AI Overviews citan preferentemente 
        fuentes con <strong>profundidad temática demostrada</strong>. Esto significa crear clusters: un 
        contenido pilar rodeado de artículos de apoyo que cubran cada ángulo del tema.
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-4">
        <li>Crea un artículo pilar exhaustivo sobre tu tema principal</li>
        <li>Desarrolla artículos satélite que profundicen en subtemas</li>
        <li>Enlaza internamente de forma lógica y semántica</li>
        <li>Actualiza regularmente con datos y tendencias nuevas</li>
      </ul>

      <h3 id="contenido-estructurado" className="text-xl font-bold text-white mt-8 mb-4">
        2. Contenido estructurado para maximizar citaciones
      </h3>
      <PostHighlight>
        El patrón QAE (Question → Answer → Evidence) aumenta hasta un 40% la probabilidad de 
        ser citado en un AI Overview.
      </PostHighlight>
      <p className="mt-4">
        Estructura tu contenido para que la IA pueda extraer respuestas fácilmente:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-4">
        <li><strong>Respuestas directas</strong> en los primeros 50-80 palabras de cada sección</li>
        <li><strong>Encabezados claros</strong> con jerarquía H2-H3 que reflejen preguntas del usuario</li>
        <li><strong>Listas y tablas</strong> para datos comparativos y pasos de acción</li>
        <li><strong>Datos originales</strong> y estadísticas verificables como evidencia</li>
      </ul>

      <h3 id="schema-markup" className="text-xl font-bold text-white mt-8 mb-4">
        3. Schema markup y datos estructurados
      </h3>
      <p>
        Los datos estructurados aumentan las tasas de citación hasta un <strong>40%</strong>. 
        Implementa Schema markup completo:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-4">
        <li><strong>FAQ Schema:</strong> para preguntas frecuentes y secciones de respuesta</li>
        <li><strong>Article Schema:</strong> con autor, fecha de publicación y actualización</li>
        <li><strong>HowTo Schema:</strong> para guías paso a paso</li>
        <li><strong>Organization Schema:</strong> para reforzar E-E-A-T y credibilidad</li>
      </ul>
    </PostSection>
  );
}
